import { Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { ArrowLeft, Printer, HardHat, Smartphone, UserPlus, BookOpen } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function PosterPage() {
  const { user } = useAuth();
  const url = `${window.location.origin}/connexion`;
  const steps = [
    [Smartphone, "Scannez le QR code avec l'appareil photo"],
    [UserPlus, "Connectez-vous avec l'identifiant donné par le chef"],
    [BookOpen, "5 minutes de français par jour"],
  ];
  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between print:hidden">
        <Link to="/equipe" data-testid="poster-back-btn" className="flex items-center gap-1 font-semibold text-slate-600 hover:text-slate-900">
          <ArrowLeft className="w-5 h-5" /> Équipe
        </Link>
        <button onClick={() => window.print()} data-testid="poster-print-btn" className="h-12 px-5 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-bold flex items-center gap-2 transition-colors">
          <Printer className="w-5 h-5" /> Imprimer
        </button>
      </div>
      <div className="certificate bg-white text-slate-900 border-[6px] border-slate-900 rounded-lg overflow-hidden" data-testid="poster-sheet">
        <div className="hazard-stripe h-6" />
        <div className="p-6 sm:p-10 text-center space-y-6">
          <div className="flex items-center justify-center gap-3">
            <span className="w-14 h-14 rounded-xl bg-orange-500 grid place-items-center"><HardHat className="w-9 h-9 text-slate-900" /></span>
            <span className="font-display text-3xl font-extrabold uppercase">Français Chantier</span>
          </div>
          <p className="font-display text-5xl sm:text-6xl font-extrabold uppercase leading-none">Apprenez le français du chantier</p>
          <div className="inline-block p-4 bg-white border-4 border-slate-900 rounded-2xl" data-testid="poster-qr">
            <QRCodeSVG value={url} size={240} level="M" />
          </div>
          <p className="text-sm font-semibold break-all" data-testid="poster-url">{url}</p>
          <div className="grid sm:grid-cols-3 gap-3 text-left">
            {steps.map(([Icon, t], i) => (
              <div key={t} className="border-2 border-slate-300 rounded-xl p-3 flex items-center gap-3">
                <span className="font-display text-3xl font-extrabold text-orange-500">{i + 1}</span>
                <Icon className="w-6 h-6 shrink-0" />
                <span className="text-sm font-semibold">{t}</span>
              </div>
            ))}
          </div>
          {user.team_id && <p className="text-base" data-testid="poster-team-note">Puis installez l'application : bouton « Installer » sur l'accueil.</p>}
        </div>
        <div className="hazard-stripe h-6" />
      </div>
    </div>
  );
}
